import React from 'react';

import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,
    FormGroup,
    Label,
    Input,
    FormFeedback,
    Row,
    Col
} from 'reactstrap';

import RGL, { WidthProvider } from "react-grid-layout";
import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'

import Isvg from 'react-inlinesvg';
import moveIcon from '../../../assets/svg/move.svg';
import moreIcon from '../../../assets/svg/more.svg';
import infoIcon from "../../../assets/svg/link-new-tab.svg";
import xIcon from '../../../assets/svg/x.svg';
import notesIcon from '../../../assets/svg/notes-icon.svg';

import PatientNotesPreview from '../../../components/patientNotesPreview';



import moment from 'moment';
import { API_ENDPOINT, getAgeLimit, translateAgeLimitMessage } from '../../../constants';
import ErrorModal_v2 from '../../../components/errorModal_v2';
import CustomSelectWithSearch from '../../../components/forms/fields/customSelectWithSearch';
import Checkbox from '../../../components/forms/fields/checkbox';
import DatePicker from '../../../components/forms/fields/datePicker';
import TimePickerV2 from '../../../components/forms/fields/timepicker_v2';
import { Player, Controls } from "@lottiefiles/react-lottie-player";
import EventMeetingsModal from '../../../components/eventMeetingsModal';
import SelectWithCheckbox from '../../../components/forms/fields/selectWithCheckbox';
import { isStringAValidNumber } from '../../../components/TwoFactorAuthModal';
import ErrorModal from '../../../components/errorModal';

import striptags from 'striptags';
import DoctorListComponent from '../../../components/forms/fields/doctorListComponent';
import InfoModal from '../../../components/infoModal';
import { addMinutesToTime } from '../helper';
import { checkRescheduleData } from '../../egenRemiss/helper';
import { isDurationHideCheckboxAvailable } from '../../referral/helper';

function isTimeValidString(timeString) {
    let valid = false;
    if (timeString?.length === 5) {
        const [hours, minutes] = timeString.split(":").map((x) => parseInt(x, 10));
        if (hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59) {
            valid = true;
        }
    }


    return valid;
}


function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}
function truncateString(str) {
    if (str.length > 210) {
        return str.substring(0, 210) + '...';
    }
    return str;
}

class ScheduleReferral extends React.Component {

    constructor(props) {
        super(props);

        this.player = React.createRef();
        this.state = {
            ...props.initialData,
            errorAdditionalDoctors: null,
            revisitForms: [],
            revisitFormsSelected: [],
            revisitFormsSelect: [],
            journalNoteFormSelected: null,
            creatingEvent: false,
            searchByNameAndEmail: false,
            doctors: [],
            clinicians: [],
            referrals: [],
            minTime: '07:00',
            maxTime: '18:00',
        }
        this.state.min = new Date();
        this.state.min.setHours(7, 0, 0)
        this.state.max = new Date();
        this.state.max.setHours(18, 0, 0)
    }

    getWorkingHours = () => {
        const doctorId = this.state.doctorId;
        const clinicId = this.props.selectedClinic;
        const groupId = this.props.selectedGroup;

        if (!doctorId || !clinicId || !groupId) return;

        const obj = {
            clinicianId: doctorId,
            clinicId: clinicId,
            groupId: groupId
        };

        fetch(API_ENDPOINT + `/data/calendar/clinician/working-hours`, {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify(obj)
        }).then(parseJSON).then(({ result, status }) => {

            let { minTime, maxTime } = result;
            if (!minTime) minTime = '07:00';
            if (!maxTime) maxTime = '18:00';

            let setObj = {};
            if (minTime !== this.state.minTime) {
                setObj.minTime = minTime;
            }
            if (maxTime !== this.state.maxTime) {
                setObj.maxTime = maxTime;
            }
            if (Object.keys(setObj).length > 0) {
                this.setState(setObj)
            }

        })
    }

    stopAnimation = () => {
        this.player.current.play();
    };



    setInitialData = () => {
        this.getDoctors();
        this.getClinicians();
        this.getAllReferrals();
    }

    getAllReferrals = () => {
        let query = { entries: 10, page: 0, group: this.props.selectedGroup, clinic: this.props.selectedClinic, doctor: this.props.uData?._id, filter: this.state.searchVisitReason ? this.state.searchVisitReason : this.state.selectRevisitForm ? this.state.searchRevisitForm : '', day: this.state.day ? this.state.day : new Date(), view: this.state.view };
        let queryFields = {};
        for (var key in query) {
            if (key && key.indexOf('query-') === 0) {
                queryFields[key.replace('query-', '')] = query[key];
            }
        }


        fetch(API_ENDPOINT + '/referrals/all', {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                doctor: query.doctor,
                group: query.group,
                clinic: query.clinic,
                sortType: query.sortType,
                sortField: query.sortField,
                lang: lang
            })
        }).then(res => res.json()).then((result) => {
            if (result) {
                this.setState({ referrals: result })
            }
        })


    }


    getDoctors = () => {
        let query = { entries: 10, page: 0, group: this.props.selectedGroup, clinic: this.props.selectedClinic, doctor: this.props.uData?._id, filter: this.state.searchVisitReason ? this.state.searchVisitReason : this.state.selectRevisitForm ? this.state.searchRevisitForm : '', day: this.state.day ? this.state.day : new Date(), view: this.state.view };
        let queryFields = {};
        for (var key in query) {
            if (key && key.indexOf('query-') === 0) {
                queryFields[key.replace('query-', '')] = query[key];
            }
        }

        fetch(API_ENDPOINT + '/users/subaccounts/doctors', {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                page: null,
                entries: null,
                filter: query.filter,
                sortType: query.sortType,
                sortField: query.sortField,
                groupId: query.group,
                clinic: query.clinic,
                query: queryFields
            })
        }).then(res => res.json()).then((result) => {
            if (result) {
                this.setState({ doctors: result })
            }
        })


    }

    getClinicians = () => {
        const clinicId = this.props.selectedClinic;
        if (!clinicId) return;

        this.setState({ clinicians: [] }, () => {
            fetch(API_ENDPOINT + `/data/calendar/doctors/${clinicId}`, {
                method: 'GET',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                }
            }).then(parseJSON).then(({ result, status }) => {
                if (result?.clinicians?.length) {
                    this.setState({ clinicians: result.clinicians }, () => {
                        // if (!this.state.doctorId && this.props.doctorId && this.state.clinicians?.find(el => el._id === this.props.doctorId)) {
                        //     this.setState({ doctorId: this.props.doctorId });
                        // }
                    });
                }
            })
        });
    }





    componentDidMount() {

        if (this.props.isOpen) {
            let data = this.props.isOpen;
            if (!data?.date || !data?.endDate || !data?.startTime || !data?.endTime) {
                let initialTime = this.generateInitialTime();
                data = {
                    ...initialTime,
                    ...data
                }
            }
            const doctorId = data?.doctor ?? null;
            this.setState({ data: data, doctorId }, () => {
                this.setInitialData();

                if (this.state.data?.patientData?._id) {
                    this.patientAge(this.state.data.patientData._id)
                }

            })
        }

    }
    componentDidUpdate(prevProps, prevState) {
        // if (prevProps.isOpen !== this.props.isOpen) {
        //     let data = this.props.isOpen;
        //     if (!data?.date || !data?.endDate || !data?.startTime || !data?.endTime) {
        //         let initialTime = this.generateInitialTime();
        //         data = {
        //             ...initialTime,
        //             ...data
        //         }
        //     }

        //     this.setState({ data: data })
        // }
        const { data, referralId } = this.state;

        if (
            JSON.stringify(prevState.data) !== JSON.stringify(data)
            || prevState.referralId !== referralId
        ) {
            this.checkPatientNotes();
        }

    }
    componentWillUnmount() {

    }

    toggle = (notToggle = false, notFetchItems = false) => {
        if (this.props.toggle) {
            this.props.toggle(notToggle, notFetchItems);
        }

    }
    formatDate = (date, format) => {
        if (!date || !format) return '';
        let dateString = date?.split(' ')?.[0];
        let timeString = date?.split(' ')?.[1];

        let DD = dateString?.split('/')[1];
        let MM = dateString?.split('/')[0];
        let YYYY = dateString?.split('/')[2];
        let HH = timeString?.split(':')[0];
        let mm = timeString?.split(':')[1];

        let formattedDate = format
            .replace('DD', DD)
            .replace('MM', MM)
            .replace('YYYY', YYYY)
            .replace('HH', HH)
            .replace('mm', mm);

        return formattedDate;

    }


    getGroupData = () => {
        let selectedGroupIdx = -1;
        if (this.props.uData && this.props.selectedGroup && this.props.uData?.clinicGroups?.length) {
            for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                    selectedGroupIdx = i;
                    break;
                }
            }
        }
        let groupData = this.props?.uData?.clinicGroups?.[selectedGroupIdx];

        return groupData;
    }
    generateInitialTime = () => {
        let tsNow = Math.floor(new Date().getTime() / 1000);
        const interval = 10 * 60;
        const ts = Math.ceil(tsNow / interval) * interval;

        let date = moment.unix(ts).format(this.props.dateFormat);
        let startTime = moment.unix(ts).format('HH:mm');
        let endTime = moment.unix(ts + 60 * 5).format('HH:mm');

        let data = {
            date,
            endDate: date,
            startTime,
            endTime,
            title: ''
        }

        return data;
    }


    setData = (data, callback) => {
        this.setState({ data }, () => {
            if (callback) {
                callback();
            }
        })
    }


    patientAge = (data, callback) => {

        let country = this.state.countryStateDict?.['search-ssn'] ?? this.props.country;

        fetch(API_ENDPOINT + '/users/users/get-age/' + data, {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                socialSecurityNumber: this.state.patientSocialSecurityNumber,
                country
            })
        }).then(res => res.json()).then((result) => {
            this.setState({
                age: result.age
            }, () => {
                if (callback) {
                    callback();
                }
            })
        })
    }

    checkDoctorsAvailable = (doctorsList, modal, callback) => {
        let event;

        event = this.state.data;

        if (doctorsList) {
            let data = {
                doctorsList: doctorsList,
                startEventReservedDateOriginal: event.date + ' ' + event.startTime,
                endEventReservedDateOriginal: event.date + ' ' + event.endTime,
                startEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(event.date + ' ' + event.startTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                endEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(event.date + ' ' + event.endTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                eventId: event.id
            }
            fetch(API_ENDPOINT + '/working-hours/check/doctors', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(res => res.json()).then((result) => {
                if (result.error) {
                    this.setState({
                        errorAdditionalDoctors: result.doctorsList
                    })
                } else {
                    this.setState({ doctorsModal: false, successfullyAdditionalDoctors: modal != 4 ? true : false }, () => {
                        // if (modal == 1) {
                        //     let updateEvent = this.state.updateEvent;
                        //     updateEvent.additionalDoctors = this.state.doctorsList;
                        //     this.setState({ updateEvent })
                        // } else if (modal == 2) {
                        //     let data = this.state.data;
                        //     data.additionalDoctors = this.state.doctorsList;
                        //     this.setState({ data })
                        // } else if (modal == 3) {
                        //     let data = this.state.data;
                        //     data.additionalDoctors = this.state.doctorsList;
                        //     this.setState({ data })
                        // }
                        let data = this.state.data;
                        data.additionalDoctors = this.state.doctorsList;
                        this.setState({ data })


                    })
                }
                if (callback) {
                    callback();
                }


            })
        }


    }

    scheduleControl = (data, checkPreScheduleInfo = false) => {
        if (!this.state.doctorId) {
            this.setState({ creatingEvent: false })
            return;
        }
        const _data = JSON.parse(JSON.stringify(data));
        let checkDate = new Date(data?.date?.replace(/-/g, "/") + ' ' + data?.startTime);
        let today = new Date();

        if (checkDate < today && (!this.state.wrongDateModal || this.state.wrongDateModal.function !== 'scheduleControl')) {
            this.setState({
                wrongDateModal: {
                    data: data,
                    checkPreScheduleInfo: checkPreScheduleInfo,
                    function: 'scheduleControl'
                }
            }, () => {
                return;
            })
        } else {
            this.setState({
                wrongDateModal: null
            })

            let templateData;
            if (data.templateData) {
                templateData = {};
                templateData._id = data.templateData?.id;
                templateData.scheduleKey = data.templateData?.scheduleKey;
                if (data.templateData?.startTime !== data.startTime || data.templateData?.endTime !== data.endTime) {
                    templateData.startTime = data.templateData?.startTime;
                    templateData.endTime = data.templateData?.endTime;
                    templateData.changedTime = true;
                }

            }
            data.journalNoteFormSelected = this.state.journalNoteFormSelected;
            if (data.controlSchedule) {
                data.patientControlNote = data.patientNote;
                data.title = data.controlSchedule.event && data.controlSchedule.event.title;
                data.socialSecurityNumber = data.controlSchedule.patient ? data.controlSchedule.patient.socialSecurityNumber : '';
                data.visitReasonOnline = data.controlSchedule.event && data.controlSchedule.event.visitReasonOnline;
                data.videoCall = data.controlSchedule.event && data.controlSchedule.event.videoCall;
                data.titleDoctor = '';
                data.revisitForms = data.controlSchedule.event && data.controlSchedule.event.revisitForms;
                data.visitReasonName = data.controlSchedule.event && data.controlSchedule.event.visitReasonName;
                data.visitReasonPrice = data.controlSchedule.event && data.controlSchedule.event.questionaryPrice ? data.controlSchedule.event.questionaryPrice : 0;
                data.visiReason = data.controlSchedule.event && data.controlSchedule.event.visiReason;
                data.hideTimeFromThePatient = data.controlSchedule.event && data.controlSchedule.event.hideTimeFromThePatient;
                // data.hideDurationForPatient = data.controlSchedule.event && data.controlSchedule.event.hideDurationForPatient;
                data.closeCaseManually = data.controlSchedule.event && data.controlSchedule.event.closeCaseManually;
                data.referralExists = data.controlSchedule ? data.controlSchedule._id : '';
                data.appointmentPaid = data.controlSchedule?.event?.appointmentPaid ? data.controlSchedule.event.appointmentPaid : false;
                data.revisitFormsArray = data.controlSchedule?.event?.revisitFormsArray ? data.controlSchedule.event.revisitFormsArray : [];
                data.journalNoteFormSelected = data.controlSchedule?.event?.journalNoteFormSelected ? data.controlSchedule.event.journalNoteFormSelected : null;
                data.visitReasonOnline = data.controlSchedule?.event?.onlineVisit ? data.controlSchedule.event.onlineVisit : false;
                data.selectedParents = data.controlSchedule?.event?.selectedParents ?? null;
                data.rescheduleRevisit = data.rescheduleRevisit ? true : false;

            }
            let noteToPatient;
            if (data?.noteToPatient?.trim()) {
                noteToPatient = {
                    note: data.noteToPatient,
                    sendNoteAsPatientNotification: data.sendNoteAsPatientNotification ? true : false
                }

                if (data.sendNoteAsPatientNotification && !checkPreScheduleInfo) {
                    this.setState({ noteToPatientPreScheduleInfo: { data: _data } })
                    return;
                }
            }
            // if (checkDate >= today) {
            this.setState({
                loading: true
            }, () => {
                // this.scheduleControlApiCalled = true;

                let obj = {
                    startEventReservedDateOriginal: data.date + ' ' + data.startTime,
                    endEventReservedDateOriginal: data.date + ' ' + data.endTime,
                    startEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.startTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                    endEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.endTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                    title: data.title,
                    socialSecurityNumber: data.socialSecurityNumber,
                    doctor: this.state.doctorId,
                    group: this.props.selectedGroup,
                    clinic: this.props.selectedClinic,
                    patientControlNote: data.patientControlNote,
                    onlineVisit: data.visitReasonOnline,
                    videoCall: data.videoCall,
                    additionalDoctors: data.additionalDoctors,
                    titleDoctor: data.titleDoctor,
                    revisitForms: data.revisitForms ? data.revisitForms : this.state.revisitFormsSelected,
                    visitReasonName: data.visitReasonName,
                    visitReasonPrice: data.visitReasonPrice,
                    visiReason: data.visiReason,
                    freePayment: data.freePayment,
                    hideTimeFromThePatient: data.hideTimeFromThePatient,
                    hideDurationForPatient: data.hideDurationForPatient,
                    closeCaseManually: data.closeCaseManually,
                    referralExists: data.referralExists ? data.referralExists : null,
                    appointmentPaid: data.appointmentPaid ? data.appointmentPaid : false,
                    revisitFormsArray: data.revisitFormsArray ? data.revisitFormsArray : [],
                    journalNoteFormSelected: data.journalNoteFormSelected,
                    rescheduleRevisit: data.rescheduleRevisit,
                    selectedParents: data.selectedParents,
                    guests: data.guests,
                    templateData: templateData,
                    noteToPatient: noteToPatient,
                    wrongDate: checkDate >= today

                };
                fetch(API_ENDPOINT + '/working-hours/control', {
                    method: 'POST',
                    headers: {
                        'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify(obj)
                }).then(res => res.json()).then((result) => {
                    if (result.error) {
                        this.setState({
                            error: result.error.translate(this.props.lang),
                            loading: false
                        })
                    } else {
                        this.toggle(result.invoiceMessage ? true : false)
                        // if (data.controlSchedule) {
                        //     this.setState({
                        //         scheduleReferral: null,
                        //         doctorsList: [],
                        //         updateEventTemplate: null,
                        //         referralId: null
                        //     }, () => this.toggle(result.invoiceMessage ? true : false))
                        // } else {
                        //     this.setState({
                        //         scheduleModal: null,
                        //         referralId: null,
                        //         scheduleControl: null,
                        //         patient: null,
                        //         age: null,
                        //         revisitFormsSelected: [],
                        //         revisitFormsSelect: [],
                        //         journalNoteFormSelected: null,
                        //         updateEventTemplate: null,
                        //         doctorsList: []

                        //     }, () => {
                        //         this.toggle(result.invoiceMessage ? true : false)
                        //     })
                        // }

                        if (result.invoiceMessage) {
                            this.setState({
                                invoiceMessage: result.invoiceMessage
                            })
                        }

                    }
                    this.setState({
                        creatingEvent: false
                    })

                })
            })
        }
        // } else {
        //     this.setState({
        //         wrongDate: true,
        //         creatingEvent: false
        //     })
        // }
    }
    scheduleReferral = (data) => {

        if (this.state.referralId) {
            for (let i = 0; i < this.state.referrals.length; i++) {
                if (this.state.referralId == this.state.referrals[i]._id) {
                    this.setState({
                        referral: this.state.referrals[i]
                    })
                }
            }
        }

        let checkDate = new Date(data.date.replace(/-/g, "/") + ' ' + data.startTime);
        let today = new Date();
        if (checkDate < today && (!this.state.wrongDateModal || this.state.wrongDateModal.function !== 'scheduleReferral')) {
            this.setState({
                wrongDateModal: {
                    data: data,
                    function: 'scheduleReferral'
                }
            }, () => {
                return;
            })
        } else {
            this.setState({
                wrongDateModal: null
            })
            // if (checkDate >= today) {
            this.setState({
                loading: true
            }, () => {
                fetch(API_ENDPOINT + '/referrals/schedule/' + this.state.referral._id, {
                    method: 'POST',
                    headers: {
                        'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify({
                        startEventReservedDateOriginal: data.date + ' ' + data.startTime,
                        endEventReservedDateOriginal: data.date + ' ' + data.endTime,
                        startPatientReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.startTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                        endPatientReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.endTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                        doctor: this.state.doctorId,
                        patientNote: data.patientNote,
                        additionalDoctors: data.additionalDoctors,
                        rescheduleReferral: data.rescheduleReferral ? true : false,
                        guests: data.guests,
                        wrongDate: checkDate >= today,
                        hideDurationForPatient: data.hideDurationForPatient
                    })
                }).then(res => res.json()).then((result) => {
                    if (result.error) {
                        this.setState({
                            error: result.error.translate(this.props.lang),
                            loading: false,
                            creatingEvent: false
                        })

                    } else {

                        this.setState({
                            creatingEvent: false
                        }, () => {
                            this.toggle(false, false)
                        })
                    }



                })
            })
        }
        // } else {
        //     this.setState({
        //         wrongDate: true,
        //         creatingEvent: false
        //     })


        // }
    }
    checkPatientNotes = () => {
        const { data } = this.state;
        let patientId, patientSSN, eventId, referralId;
        if (data && this.state.referralId) {
            let referral = this.state.referrals.find(item => item._id === this.state.referralId);
            if (referral?.patient?.socialSecurityNumber) patientSSN = referral.patient.socialSecurityNumber;
            if (referral?._id) referralId = referral._id;
        }

        if (!patientId && !patientSSN && !eventId && !referralId) {
            this.setState({ patientNotes: [] })

            return;
        }
        let obj = {
            patientId,
            patientSSN,
            eventId,
            referralId,
            clinicId: this.props.selectedClinic,
            groupId: this.props.selectedGroup,
            lang: this.props.lang
        };

        this.setState({ patientNotes: [] }, () => {
            fetch(API_ENDPOINT + `/user/patients-notes/fetch`, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(obj)
            }).then(res => res.json()).then((result) => {
                if (result?.items?.length) {
                    this.setState({ patientNotes: result.items });
                }
            })
        })

    }


    render() {
        const isOpen = this.props.isOpen ? true : false;
        if (!isOpen || !this.state.data) return null;

        const groupData = this.getGroupData();
        const enterprise = groupData?.enterprise;
        const eventMeetings = groupData?.eventMeetings ?? false;

        const AGE_LIMIT = getAgeLimit(this.props.country, this.props.selectedGroup, this.props.clinicsAgeLimitExceptions);
        const isChild = typeof this.state.age === 'number' && this.state.age < AGE_LIMIT ? true : false;



        const patientData = this.state.data?.patientData ?? null;

        const doctorId = this.state.doctorId ?? null;
        const disabledDoctorSelect = this.props.isOpen?.doctor && this.props.isOpen?.disabledDoctorSelect !== false ? true : false;

        const humanReadable = {
            'waiting-for-approval': 'Waiting for approval',
            'disallowed': 'Disallowed',
            'allowed': 'Allowed',
            'return-for-update': 'Return for update',
            'patient-requested-another-time': 'Patient requested anoother time',
            'patient-rejected': 'Cancelled by patient', // 'Rejected by patient',
            'patient-accepted': 'Patient accepted',
            'clinic-accepted-requested-time': 'Clinic accepted requested time',
            'clinic-rejected-requested-time': 'Clinic rejected requested time',
            'approved-by-region-manager': 'Approved by region manager',
            'rejected-by-region-manager': 'Rejected by region manager',
            'scheduled': 'Scheduled',
            'canceled-by-clinic': 'Cancelled by clinician', // 'Canceled by clinic'
            'not-booked': 'Cancelled by clinician', //'Not booked',
            'closed': 'Closed',
            'requested-new-appointment': 'Requested new appointment'.translate(this.props.lang),
            'visit-rescheduled': 'Visit rescheduled'.translate(this.props.lang),
            'external': 'External transfer'.translate(this.props.lang),
            'not-scheduled': 'Not scheduled',

        }
        const { minTime, maxTime } = this.state;
        return (
            <>

                <Modal isOpen={isOpen} centered>
                    <ModalHeader
                        toggle={() => this.toggle(false, true)}
                        close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.toggle(false, true)}>&times;</button>}
                    >
                        {'Schedule referral'.translate(this.props.lang)}
                    </ModalHeader>

                    <ModalBody>
                        <FormGroup>
                            <Label>{'Doctor'.translate(this.props.lang) + '*'}</Label>
                            <Input type='select' value={doctorId} disabled={disabledDoctorSelect} onChange={(e) => {
                                let value = e.target.value;
                                if (value === '-1') value = null;
                                this.setState({ doctorId: value }, () => {
                                    this.getWorkingHours();
                                    let data = this.state.data;
                                    if (this.state.doctorId && data?.additionalDoctors?.find(el => el === this.state.doctorId)) {
                                        data.additionalDoctors = data.additionalDoctors.filter(el => el !== this.state.doctorId);
                                        this.setData(data);
                                    }
                                    if (this.state.doctorId && this.state.doctorsList?.find(el => el === this.state.doctorId)) {
                                        let doctorsList = this.state.doctorsList;
                                        doctorsList = doctorsList.filter(el => el !== this.state.doctorId);
                                        this.setState({ doctorsList })
                                    }
                                })

                            }}>
                                <option value={'-1'}>{'Select doctor'.translate(this.props.lang)}</option>
                                {
                                    this.state.clinicians.map((item, idx) => {
                                        return (
                                            <option value={item._id} key={idx}>{item.name}</option>
                                        )
                                    })
                                }
                            </Input>
                        </FormGroup>
                        <FormGroup>
                            <Label>{'Patient'.translate(this.props.lang)}</Label>

                            <div className={this.state.selectOpen ? 'custom-select-with-search-open' : 'custom-select-with-search-closed'}
                                onClick={() => {
                                    this.setState({
                                        selectOpen: !this.state.selectOpen
                                    })
                                }}
                            >
                                {this.state.referrals.filter(item => (item.status == 'allowed' || item.status == 'not-booked' || item.status == 'canceled-by-clinic' || item.status === 'requested-new-appointment') && item.recipientClinic == this.props.selectedClinic).map(item => {
                                    if (item._id === this.state.referralId && this.state.referralId)
                                        return <div>

                                            {item.patient && item.patient.referralNumber} - {item.patient.name}{" " + humanReadable[item.status].translate(this.props.lang)}{item.onlineVisit ? (' - ' + 'Online'.translate(this.props.lang)) : ''}

                                        </div>
                                })}

                            </div>

                            {
                                this.state.selectOpen ?
                                    <div className='custom-select-with-search-items'>
                                        <CustomSelectWithSearch
                                            lang={this.props.lang}
                                            items={this.state.referrals.filter(item => (item.status == 'allowed' || item.status == 'not-booked' || item.status == 'canceled-by-clinic' || item.status === 'requested-new-appointment') && item.recipientClinic == this.props.selectedClinic && this.state.doctor != item.patientId).map((item, idx) => {
                                                return {
                                                    name: item.patient && item.patient.referralNumber + ' - ' + item.patient.name + " " + humanReadable[item.status].translate(this.props.lang) + (item.onlineVisit ? (' - ' + 'Online'.translate(this.props.lang)) : ''),
                                                    value: item._id
                                                }
                                            })}
                                            value={this.state.referralId}
                                            maxHeight={'250px'}
                                            onChange={async (e) => this.setState({ referralId: e.value != -1 ? e.value : null }, async () => {
                                                let index = this.state.referrals.findIndex(ref => ref._id.toString() == this.state.referralId.toString())
                                                if (this.state.referrals[index] && this.state.referrals[index].remissType === 'Revisit') {
                                                    let data = this.state.data;
                                                    data.controlSchedule = this.state.referrals[index];

                                                    data.referralId = this.state.referrals[index]._id;
                                                    data = await checkRescheduleData(data, this.props, true, true)

                                                    let setObj = {
                                                        data
                                                    }
                                                    if (data?.rescheduledData?.doctorId && this.state.clinicians?.find(el => el._id === data?.rescheduledData?.doctorId)) {
                                                        setObj.doctorId = data?.rescheduledData?.doctorId;
                                                    }
                                                    if (data?.rescheduledData?.startTime) {
                                                        this.registerChangeTimePickerStartTime();
                                                        this.registerChangeTimePickerEndTime();
                                                    }
                                                    this.setState(setObj, () => {
                                                        if (setObj.doctorId && this.state.doctorId) {
                                                            this.getWorkingHours();

                                                            if (this.state.doctorId && data?.additionalDoctors?.find(el => el === this.state.doctorId)) {
                                                                data.additionalDoctors = data.additionalDoctors.filter(el => el !== this.state.doctorId);
                                                                this.setData(data);
                                                            }
                                                            if (this.state.doctorId && this.state.doctorsList?.find(el => el === this.state.doctorId)) {
                                                                let doctorsList = this.state.doctorsList;
                                                                doctorsList = doctorsList.filter(el => el !== this.state.doctorId);
                                                                this.setState({ doctorsList })
                                                            }
                                                        }
                                                    })
                                                    // this.setState({
                                                    //     data
                                                    // })
                                                }

                                                this.setState({
                                                    selectOpen: false
                                                })
                                            })}
                                        />
                                    </div>
                                    :
                                    null
                            }


                        </FormGroup>

                        <DatePicker
                            label={'Date'.translate(this.props.lang)}
                            value={this.state.data.date}
                            holidayEvents={this.state.holidayEvents}
                            onChange={(e) => {
                                let data = this.state.data;
                                data.date = e;
                                this.setState({
                                    data
                                })
                                if (Math.floor(new Date(this.state.data.date + ' ' + this.state.data.startTime) / 1000) > Math.floor(new Date(this.state.data.endDate + ' ' + this.state.data.endTime) / 1000)) {
                                    data.endDate = this.state.data.date
                                    this.setState({
                                        data
                                    })
                                }
                            }}
                        />
                        <FormGroup className="timepicker-container timepicker-wide">
                            <Label>{'Start time'.translate(this.props.lang)}</Label>
                            &nbsp;
                            <TimePickerV2
                                getStringDateTs={this.props.getStringDateTs}
                                format={'HH:mm'}
                                value={this.state.data.startTime}
                                // minValue={this.props.getStringDateTs(Math.floor(this.state.min.getTime() / 1000), 'HH:mm')}
                                // maxValue={this.props.getStringDateTs(Math.floor(this.state.max.getTime() / 1000 - 300), 'HH:mm')}
                                minValue={minTime}
                                maxValue={addMinutesToTime(maxTime, -5)}
                                flag={0}
                                onChange={(time1, timeString) => {

                                    let data = this.state.data;
                                    data.startTime = timeString

                                    let startTimeSplit = data.startTime.split(":");
                                    let endTimeSplit = data.endTime.split(":");

                                    let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                    let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                                    if (startTimeHourMinute < endTimeHourMinute) {
                                        this.setState({ data })
                                    } else {
                                        data.endTime = Math.trunc((Number(this.state.data.startTime.split(':')[0]) * 60 + Number(this.state.data.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.data.startTime.split(':')[0]) * 60 + Number(this.state.data.startTime.split(':')[1]) + 5) % 60
                                        const padded = data?.endTime?.split?.(':');
                                        if (padded && Array.isArray(padded) && padded.length && isStringAValidNumber(padded[0]) && isStringAValidNumber(padded[1])) {
                                            const h = padded[0]?.padStart?.(2, '0');
                                            const m = padded[1]?.padStart?.(2, '0');
                                            if (h && m) data.endTime = `${h}:${m}`;
                                        }
                                        this.setState({
                                            data
                                        })
                                    }
                                }}
                                registerHandleBlur={(value) => this.registerChangeTimePickerStartTime = value}
                            />

                        </FormGroup>
                        <FormGroup className="timepicker-container timepicker-wide">
                            <Label>{'End time'.translate(this.props.lang)}</Label>
                            &nbsp;
                            <TimePickerV2
                                getStringDateTs={this.props.getStringDateTs}
                                format={'HH:mm'}
                                value={this.state.data.endTime}
                                minValue={Math.trunc((Number(this.state.data.startTime.split(':')[0]) * 60 + Number(this.state.data.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.data.startTime.split(':')[0]) * 60 + Number(this.state.data.startTime.split(':')[1]) + 5) % 60}
                                // maxValue={this.props.getStringDateTs(Math.floor(this.state.max.getTime() / 1000), 'HH:mm')}
                                maxValue={maxTime}
                                flag={0}
                                onChange={(time1, timeString) => {

                                    let data = this.state.data;
                                    data.endTime = timeString


                                    let startTimeSplit = data.startTime.split(":");
                                    let endTimeSplit = data.endTime.split(":");

                                    let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                    let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                                    if (startTimeHourMinute < endTimeHourMinute) {
                                        this.setState({ data })
                                    }
                                }}
                                registerHandleBlur={(value) => this.registerChangeTimePickerEndTime = value}
                            />

                        </FormGroup>
                        {
                            this.state.referralId && isDurationHideCheckboxAvailable(this.state.referralId, null, this.state.referrals) /* && enterprise */ ?
                                <FormGroup style={{ display: 'flex', alignItems: 'center' }}>
                                    <Checkbox
                                        onChange={(e) => {
                                            let data = this.state.data;
                                            data.hideDurationForPatient = e.target.checked;
                                            this.setState({
                                                data
                                            })
                                        }}
                                        checked={this.state.data.hideDurationForPatient}
                                        label={'Hide duration for patient'.translate(this.props.lang)}
                                    />
                                    <div className='button-elements-tooltip' style={{ marginLeft: 8 }}>
                                        <Isvg src={infoIcon} style={{ width: 25 }} />
                                        <div className='tooltip-text' style={{ minWidth: 180, bottom: 29 }}>{'Duration is not displayed to the patient.'.translate(this.props.lang)}</div>
                                    </div>
                                </FormGroup>
                                :
                                null
                        }
                        {
                            this.state.referralId ?
                                <FormGroup>
                                    <Label className='note-label-wrap'>{'Note'.translate(this.props.lang)}
                                        <div className={this.state.patientNotes?.length ? 'notes-icon-wrap notes-icon-active' : 'notes-icon-wrap'} onClick={() => { this.setState({ showPatientNotes: true }) }}>
                                            <Isvg src={notesIcon} />
                                            <div className='tooltip-text'>{'Notes available'.translate(this.props.lang)}</div>
                                        </div>
                                    </Label>
                                    <Input type='textarea'
                                        name="note"
                                        style={{ height: '150px' }}
                                        onChange={(e) => {
                                            let data = this.state.data;
                                            data.patientNote = striptags(e.target.value);
                                            this.setState({
                                                data
                                            })
                                        }}
                                        value={this.state.data.patientNote}
                                    />
                                </FormGroup>
                                :
                                null
                        }
                        {
                            this.state.referralId && this.state.data?.rescheduledMessage ?
                                <div className='rescheduled-message-schedule-modal'>
                                    *{this.state.data?.rescheduledMessage}
                                </div>
                                :
                                null
                        }
                        <div className='calendar-modal-buttons-wrap'>
                            {
                                this.state.referralId ?
                                    <FormGroup>
                                        <Button onClick={() => this.setState({
                                            doctorsModal: 2
                                        })} color="primary">
                                            {'Add caregiver'.translate(this.props.lang)}
                                        </Button>
                                    </FormGroup>

                                    :

                                    null
                            }
                            {
                                this.state.referralId && eventMeetings ?
                                    <FormGroup>
                                        <Button
                                            onClick={() => {
                                                let guests = [];
                                                if (this.state.data?.guests) {
                                                    guests = [...this.state.data.guests];
                                                }
                                                this.setState({
                                                    eventMeetingsModal: { ...this.state.data, guests, modal: 'data' }
                                                })
                                            }}
                                            color="primary"
                                        >
                                            {'Add guest'.translate(this.props.lang)}
                                        </Button>
                                    </FormGroup>

                                    :

                                    null
                            }
                        </div>


                        <Button color='primary' disabled={this.state.referralId && !this.state.creatingEvent && this.state.doctorId ? false : true} onClick={() => {
                            this.setState({
                                creatingEvent: true
                            }, () => {
                                if (this.state.referrals) {
                                    let index = this.state.referrals.findIndex(ref => ref._id.toString() == this.state.referralId.toString())
                                    if (this.state.referrals[index] && this.state.referrals[index].remissType === 'Revisit') {
                                        this.scheduleControl({ ...this.state.data, rescheduleRevisit: true })
                                    } else {
                                        if (this.state.referrals[index] && this.state.referrals[index].status === 'requested-new-appointment') {
                                            this.scheduleReferral({ ...this.state.data, rescheduleReferral: true })
                                        } else {
                                            this.scheduleReferral({ ...this.state.data, rescheduleReferral: false })
                                        }

                                    }
                                }
                            })


                        }}>{'Schedule referral'.translate(this.props.lang)}</Button>

                    </ModalBody>
                </Modal>
                {
                    this.state.showPatientNotes ?
                        <PatientNotesPreview
                            {...this.props}
                            isOpen={this.state.showPatientNotes}
                            items={this.state.patientNotes}
                            toggle={() => this.setState({ showPatientNotes: !this.state.showPatientNotes })}
                            showInModal={true}
                        />
                        :
                        null
                }


                {
                    this.state.successfullyAdditionalDoctors ?
                        <InfoModal
                            isOpen={this.state.successfullyAdditionalDoctors}
                            toggle={() => this.setState({ successfullyAdditionalDoctors: !this.state.successfullyAdditionalDoctors })}
                            header={'Info'.translate(this.props.lang)}
                            info={`All doctors were successfully added`.translate(this.props.lang)}
                            buttons={[
                                <Button color="primary" style={{ margin: 10 }} onClick={() => this.setState({ successfullyAdditionalDoctors: false })}>{'Ok'.translate(this.props.lang)}</Button>,

                            ]}

                        />
                        :
                        null
                }
                {
                    this.state.doctorsModal ?
                        <Modal isOpen={this.state.doctorsModal} centered toggle={() => this.setState({ doctorsModal: !this.state.doctorsModal })} >
                            <ModalHeader toggle={() => this.setState({ doctorsModal: !this.state.doctorsModal })} close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ doctorsModal: !this.state.doctorsModal })}><Isvg src={xIcon} /></button>}>{'Choose doctors'.translate(this.props.lang)}</ModalHeader>

                            <ModalBody className="run-modal">

                                {
                                    this.state.doctors && this.state.doctors.length && this.state.doctors.filter((item) => {
                                        if (item._id != this.state.doctorId) {
                                            return true;
                                        } else {
                                            return false;
                                        }
                                    }).length ?
                                        <FormGroup >
                                            <Label>{'Search'.translate(this.props.lang)}</Label>
                                            <Input type='text' value={this.state.filterDoctors ? this.state.filterDoctors : ''} onChange={(e) => {
                                                this.setState({
                                                    filterDoctors: e.target.value
                                                })
                                            }} />

                                        </FormGroup>
                                        :
                                        null
                                }

                                <FormGroup >
                                    {
                                        this.state.doctors && this.state.doctors.length && this.state.doctors.filter((item) => {
                                            if (item._id != this.state.doctorId) {
                                                return true;
                                            } else {
                                                return false;
                                            }
                                        }).length ?
                                            <DoctorListComponent

                                                value={this.state.doctorsList ? this.state.doctorsList : []}
                                                values={this.state.doctors.filter(el =>
                                                    (!this.state.updateEvent || (this.state.updateEvent && this.state.updateEvent.patientId != el._id))
                                                    && (!this.state.scheduleReferral || (this.state.scheduleReferral && this.state.referralId && this.state.referrals.filter(ref => ref._id == this.state.referralId) && this.state.referrals.filter(ref => ref._id == this.state.referralId)[0] && this.state.referrals.filter(ref => ref._id == this.state.referralId)[0].patientId != el._id))
                                                    && (!this.state.data || (this.state.data && this.state.data.patient != el._id))
                                                ).sort((a, b) => {
                                                    const nameA = a.name;
                                                    const nameB = b.name;
                                                    if (nameA < nameB) {
                                                        return -1
                                                    }
                                                    if (nameA > nameB) {
                                                        return 1
                                                    }
                                                }).filter(doc => doc._id !== this.state.doctorId && doc.name.toLowerCase().indexOf(this.state.filterDoctors ? this.state.filterDoctors.toLowerCase() : ' ') != -1).map(item => {
                                                    return ({
                                                        name: item.name,
                                                        value: item._id,
                                                        profilePicture: item.profilePicture,
                                                        username: item.username
                                                    })
                                                })}
                                                onChange={(item) => {
                                                    let doctorsList = this.state.doctorsList;
                                                    doctorsList = [...item]
                                                    this.setState({ doctorsList })
                                                }}
                                            />

                                            :
                                            "The doctor's list is empty".translate(this.props.lang)
                                    }
                                </FormGroup>


                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                {
                                    this.state.doctors && this.state.doctors.length && this.state.doctors.filter((item) => {
                                        if (item._id != this.state.doctorId) {
                                            return true;
                                        } else {
                                            return false;
                                        }
                                    }).length ?
                                        <Button color='primary'
                                            onClick={() =>
                                                this.checkDoctorsAvailable(this.state.doctorsList, this.state.doctorsModal)
                                            }>{'Add'.translate(this.props.lang)}</Button>
                                        :
                                        null
                                }
                                <Button color='primary' onClick={() => {
                                    this.setState({ doctorsModal: false })
                                }
                                }>{"Close".translate(this.props.lang)}</Button>
                            </ModalFooter>
                        </Modal>
                        :
                        null
                }





                {
                    this.state.eventMeetingsModal ?
                        <EventMeetingsModal
                            {...this.props}
                            data={this.state.eventMeetingsModal}
                            doctorId={this.state.doctorId}
                            onClose={() => this.setState({ eventMeetingsModal: null })}
                            closeButtonText={'Close without saving'.translate(this.props.lang)}
                            saveData={(data) => {
                                let setObj = { eventMeetingsModal: null };
                                let modal = this.state.eventMeetingsModal?.modal;
                                if (data && modal) {
                                    if (modal === 'data') {
                                        let eventObj = this.state.data;
                                        eventObj.guests = data;
                                        this.setData(eventObj)
                                    }
                                }
                                this.setState(setObj)
                            }}
                        />
                        :
                        null
                }
                {
                    this.state.errorOverlap ?
                        <Modal
                            isOpen={this.state.errorOverlap}
                            centered
                        >
                            <ModalBody className="delete-modal">
                                <div className='message'>
                                    {'Bookings in your calendar already exist for the selected period'.translate(this.props.lang)}
                                </div>
                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                <Button
                                    color='primary'
                                    disabled={this.state.loadingUpdate}
                                    style={{ margin: 10, minWidth: 100 }}
                                    onClick={() => {
                                        const data = this.state.errorOverlap?.data;
                                        const _data = this.state.errorOverlap?._data;
                                        const updateAllRecurringEvents = this.state.errorOverlap?.updateAllRecurringEvents;
                                        if (data) {
                                            this.updateEventTypeEvent(data, updateAllRecurringEvents, true)
                                        } else if (_data) {
                                            this.scheduleEvent(_data, true)
                                        }
                                    }}>
                                    {'Continue anyways'.translate(this.props.lang)}
                                </Button>
                                <Button
                                    color='primary'
                                    disabled={this.state.loadingUpdate}
                                    style={{ margin: 10, minWidth: 100 }}
                                    onClick={() => {
                                        this.setState({
                                            errorOverlap: null
                                        })
                                    }}>{'Go back'.translate(this.props.lang)}</Button>
                            </ModalFooter>
                        </Modal>

                        : null
                }
                {
                    this.state.error ?

                        <ErrorModal lang={this.props.lang}
                            isOpen={this.state.error}
                            toggle={() => this.setState({ error: null })}
                        >
                            {this.state.error}
                        </ErrorModal>

                        :
                        null
                }
                {
                    this.state.wrongDate ?
                        <Modal isOpen={this.state.wrongDate} centered>
                            <ModalBody className="delete-modal">
                                <p className='message'>{'You can not pick date form the past'.translate(this.props.lang)}</p>
                            </ModalBody>
                            <ModalFooter className="buttons-right-blue">
                                <Button style={{ minWidth: 100 }} color='primary' onClick={() => this.setState({ wrongDate: !this.state.wrongDate })}>{'Pick again'.translate(this.props.lang)}</Button>
                            </ModalFooter>
                        </Modal>
                        : null
                }
                {
                    this.state.errorAdditionalDoctors ?

                        <ErrorModal lang={this.props.lang}
                            isOpen={this.state.errorAdditionalDoctors}
                            toggle={() => {
                                this.setState({ errorAdditionalDoctors: null })
                            }}

                        >
                            {
                                this.state.errorAdditionalDoctors && this.state.errorAdditionalDoctors.map((item, idx) => {
                                    return (
                                        <div>
                                            <span style={{ fontWeight: 600 }}>
                                                {item.doctorName}  {' - '}
                                            </span>

                                            {
                                                item.available ?
                                                    <span style={{ color: 'green' }}>{'Available'.translate(this.props.lang)}</span>
                                                    :
                                                    <span style={{ color: 'red' }}>{'Unavailable'.translate(this.props.lang)}</span>
                                            }

                                        </div>
                                    )
                                })

                            }
                        </ErrorModal>
                        :
                        null
                }
                {
                    this.state.noteToPatientPreScheduleInfo ?
                        <Modal isOpen={this.state.noteToPatientPreScheduleInfo} centered >
                            <ModalBody className="delete-modal">
                                <div className='message'>{'Are you sure you also want to send the note as a notification? Depending on the content of your note and your settings, sensitive information might be shared via SMS/email/push.'.translate(this.props.lang)}</div>
                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                <Button color='primary' style={{ margin: 10, minWidth: 100 }}
                                    disabled={this.state.loading}
                                    onClick={() => {
                                        const data = this.state.noteToPatientPreScheduleInfo?.data;
                                        if (data) {
                                            this.setState({ noteToPatientPreScheduleInfo: null }, () => {
                                                this.scheduleControl(data, true)
                                            });
                                        }
                                    }}>
                                    {this.state.loading ? /*'Processing...'.translate(this.props.lang)*/

                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <Player
                                                onEvent={() => {
                                                    if (!this.state.loading) this.stopAnimation();
                                                }}
                                                onStateChange={this.toggleVisibility}
                                                ref={this.player} // set the ref to your class instance
                                                autoplay={true}
                                                loop={true}
                                                controls={true}
                                                src="https://assets8.lottiefiles.com/packages/lf20_ZSRKCF.json"
                                                style={{ height: "20px", width: "30px" }}
                                            ></Player>
                                            {'Processing...'.translate(this.props.lang)}
                                        </div>

                                        : 'Continue'.translate(this.props.lang)}
                                </Button>
                                <Button color='primary' style={{ margin: 10, minWidth: 100 }} onClick={() => {
                                    this.setState({
                                        noteToPatientPreScheduleInfo: !this.state.noteToPatientPreScheduleInfo,
                                        creatingEvent: false
                                    })
                                }}>{'Go back'.translate(this.props.lang)}</Button>
                            </ModalFooter>
                        </Modal>

                        : null
                }
                {
                    this.state.wrongDateModal ?
                        <InfoModal
                            isOpen={this.state.wrongDateModal}
                            onClose={(item) => {
                                this.setState({
                                    wrongDateModal: null
                                })
                            }}
                            info={"This event has already occurred. When saving changes, no notifications will be sent out.".translate(this.props.lang)}
                            buttons={[
                                <Button
                                    // color='success'
                                    style={{ margin: 10, border: 'none' }}
                                    onClick={() => {

                                        if (this.state.wrongDateModal?.function === 'scheduleControl') {
                                            this.scheduleControl(this.state.wrongDateModal?.data, this.state.wrongDateModal?.checkPreScheduleInfo)
                                        } else if (this.state.wrongDateModal?.function === 'scheduleReferral') {
                                            this.scheduleReferral(this.state.wrongDateModal?.data);
                                        }

                                    }}
                                >
                                    {"Save".translate(this.props.lang)}
                                </Button>,
                                <Button
                                    // color='danger'
                                    style={{ margin: 10, border: 'none' }}
                                    onClick={() => this.setState({
                                        wrongDateModal: null,
                                        creatingEvent: null
                                    })}
                                >
                                    {'Go back'.translate(this.props.lang)}
                                </Button>,
                            ]}
                        />
                        :
                        null
                }
                {
                    this.state.invoiceMessage ?
                        <InfoModal
                            isOpen={this.state.invoiceMessage}
                            onClose={(item) => {
                                this.setState({
                                    invoiceMessage: item
                                })
                            }}
                            info={this.state.invoiceMessage.translate(this.props.lang)}
                            buttons={[
                                <Button
                                    style={{ margin: 10, border: 'none' }}
                                    onClick={() => this.props[0].history.push('/my-data/clinic/payments')}
                                >
                                    {"Go to payment".translate(this.props.lang)}
                                </Button>,
                                <Button
                                    // color='danger'
                                    style={{ margin: 10, border: 'none' }}
                                    onClick={() => {
                                        this.setState({
                                            invoiceMessage: null
                                        }, () => {
                                            this.toggle();
                                        })
                                    }}
                                >
                                    {'Close'.translate(this.props.lang)}
                                </Button>,
                            ]}
                        />
                        :
                        null
                }


            </>


        )
    }
}

export default ScheduleReferral;